import LTR from "@brand-icons/global/social-snapchat/social-snapchat-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialSnapchatIcon = iconFactory("SocialSnapchatIcon", LTR);
